module.exports = __webpack_public_path__ + "img/icon2.e91d1796.svg";